export default class TextSimilarityUtil {

    // Compare strings a and b using Damerau-Levenshtein distance
    // Return a similarity between 1 (identical) and 0
    static getTextSimilarity(a, b) {

        a = a.toLowerCase()
        b = b.toLowerCase()
        a = this.removeSpecialCharacters(a)
        b = this.removeSpecialCharacters(b)

        if (a === b) {
            return 1;
        }

        const lenA = a.length;
        const lenB = b.length;

        if (lenA === 0 || lenB === 0) {
            return 0;
        }

        const matrix = [];

        for (let i = 0; i <= lenA; i++) {
            matrix[i] = [i];
        }

        for (let j = 1; j <= lenB; j++) {
            matrix[0][j] = j;
        }

        for (let i = 1; i <= lenA; i++) {

            for (let j = 1; j <= lenB; j++) {

                const cost = a[i - 1] === b[j - 1] ? 0 : 1;

                matrix[i][j] = Math.min(
                    matrix[i - 1][j] + 1,
                    matrix[i][j - 1] + 1,
                    matrix[i - 1][j - 1] + cost
                );

                if (i > 1 &&
                    j > 1 &&
                    a[i - 1] === b[j - 2] &&
                    a[i - 2] === b[j - 1]
                ) {
                    matrix[i][j] = Math.min(
                        matrix[i][j],
                        matrix[i - 2][j - 2] + cost
                    );
                }
            }
        }

        const distance = matrix[lenA][lenB];

        return 1 - distance / Math.max(lenA, lenB);
    }

    static removeSpecialCharacters(string) {
        return string.replace(/[^\p{L}\p{N}\s]/gu, '')
    }

}
